module.exports = __webpack_public_path__ + "static/keyboardshortcut-function-dont-3f709fa1549ffd6253aba4674cc3486b.png";